const COMMON_PASSWORDS = new Set([
  'password',
  'password1',
  'password123',
  '12345678',
  '123456789',
  '1234567890',
  'qwerty123',
  'letmein',
  'welcome1',
  'admin123',
  'changeme',
]);

export const PASSWORD_RULES = [
  {
    id: 'length',
    label: 'At least 10 characters',
    test: (p) => p.length >= 10,
  },
  {
    id: 'upper',
    label: 'One uppercase letter',
    test: (p) => /[A-Z]/.test(p),
  },
  {
    id: 'lower',
    label: 'One lowercase letter',
    test: (p) => /[a-z]/.test(p),
  },
  {
    id: 'number',
    label: 'One number',
    test: (p) => /\d/.test(p),
  },
  {
    id: 'special',
    label: 'One special character (!@#$%…)',
    test: (p) => /[^A-Za-z0-9]/.test(p),
  },
];

export function analyzePassword(password, email = '') {
  const rules = PASSWORD_RULES.map((rule) => ({
    ...rule,
    met: rule.test(password),
  }));

  const localPart = email.split('@')[0]?.toLowerCase() || '';
  const notCommon = !COMMON_PASSWORDS.has(password.toLowerCase());
  const notEmailPart =
    !localPart || localPart.length < 3 || !password.toLowerCase().includes(localPart);

  const extra = [
    {
      id: 'not_common',
      label: 'Not a common password',
      met: password.length === 0 ? false : notCommon,
    },
    {
      id: 'not_email',
      label: 'Does not contain your email',
      met: password.length === 0 ? false : notEmailPart,
    },
  ];

  const allRules = [...rules, ...extra];
  const metCount = allRules.filter((r) => r.met).length;
  const requiredMet = rules.every((r) => r.met) && notCommon && notEmailPart;

  let strength = 0;
  if (password.length > 0) {
    strength = Math.round((metCount / allRules.length) * 100);
    if (password.length >= 14 && requiredMet) strength = Math.min(100, strength + 10);
  }

  let strengthLabel = 'Too weak';
  let strengthColor = 'bg-red-500';
  if (strength >= 85) {
    strengthLabel = 'Strong';
    strengthColor = 'bg-green-500';
  } else if (strength >= 65) {
    strengthLabel = 'Good';
    strengthColor = 'bg-teal-500';
  } else if (strength >= 40) {
    strengthLabel = 'Fair';
    strengthColor = 'bg-amber-500';
  }

  return {
    rules: allRules,
    strength,
    strengthLabel,
    strengthColor,
    isValid: requiredMet,
  };
}

export function passwordsMatch(password, confirm) {
  return password.length > 0 && password === confirm;
}
